import {AfterViewInit, Component, EventEmitter, HostBinding, HostListener, Input, Output} from '@angular/core';
import {Video} from "../../models/video.model";
import {findVideoData} from "../../defines/client.const";
import {VideoBoxComponent} from "./video-box.component";
import {VideoHistoryService} from "../../services/video/video-history.service";
import {VideoBookmarkService} from "../../services/video/video-bookmark.service";
import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {VoiceService} from "../../services/voice/voice.service";

@Component({
  selector: 'app-video-total-item',
  styleUrls: ['./video-total-item.component.scss'],
  template: `
    <ng-container *ngIf="video">

      <div class="img-box {{ video.new ? 'type-new' : '' }}">
        <img src="{{ makeYoutubeUrl(video.youtubeId) }}" alt="유튜브 이미지">
        <div class="label-list">
          <!-- div class="label-box main-type{{ GetRegion2Css(video.area1) }}"
               *ngIf="video.area1">
            {{ GetRegion2Name(video.area1) }}</div -->
          <div class="label-box sub-type{{ GetRegion2Css(video.area1) }}"
               *ngIf="video.area2">
            {{ video.area2 }}</div>
        </div>

      </div>

      <div class="con-box">
        <article class="bookmark-btn-box">
          <a class="bookmark-btn {{ getBmCss(video) }}"
             (click)="ToggleBookmark($event, video)"></a>
        </article>

        <!-- div class="tit-box type{{ findVideoData(video.category).cssIdx }}">{{ findVideoData(video.category).name }}</div -->
        <div
          class="tit-box type{{ findVideoData(video.category)?.cssIdx }}">{{ findVideoData(video.category)?.name }}</div>

        <div class="des-box"
             [innerHTML]="video.title | resize">
        </div>
      </div>

    </ng-container>
  `,
})
export class VideoTotalItemComponent extends VideoBoxComponent implements AfterViewInit {
  @HostBinding('class') override class = 'video-item-box';
  // @HostBinding('class.type-new') get isNew() { return this.video?.new; }
  // @HostBinding('style.display') styleBlock = 'inline-block';
  @Input() override video?: Video;
  @Output() viewInit: EventEmitter<Video> = new EventEmitter<Video>();

  constructor(
    protected override historySvc: VideoHistoryService,
    protected override bmSvc: VideoBookmarkService,
    protected override voice: VoiceService,
    protected override lm: LayoutMgrService,
    protected override globalEventSvc: GlobalEventService,
  ) {
    super(historySvc, bmSvc, voice, lm, globalEventSvc);
  }

  protected readonly findVideoData = findVideoData;

  ngAfterViewInit() {
    this.viewInit.emit(this.video);
  }
}
